export default {
  pageTitle: 'Fabrikasi Heat Exchanger',
  metaDescription: 'TEF memfabrikasi heat exchanger shell & tube, reboiler, kondensor, dan cooler berbahan copper-nickel, titanium, dan duplex stainless steel untuk industri proses.',
  sidebar: {
    title: 'Daftar Fabrikasi',
    vessel: 'Fabrikasi Vessel',
    heatExchanger: 'Fabrikasi Heat Exchanger',
    piping: 'Fabrikasi Piping',
    tower: 'Fabrikasi Tower',
    muffle: 'Fabrikasi Muffle',
    radiantTube: 'Fabrikasi Radiant Tube',
    otherEquipment: 'Fabrikasi Other Equipment',
  },
  fabricationOf: 'Fabrikasi',
  product: {
    name: 'Heat Exchanger',
    desc: 'Berikut adalah katalog pengalaman kami dalam fabrikasi Heat Exchanger dengan berbagai jenis material, tipe, dan spesifikasi.',
  },
};
